import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import Vuex from "vuex";
import menuData from "@/assets/myMenu.json";
import mhd001 from "@/assets/page101.json";
import mhd003 from "@/assets/mhd003.json";
import hdc001 from "@/assets/hdc001.json";
import regions from "@/assets/regions.json";
import { statusParams } from "./statusParams.js";
import { moduleMsg } from "./message.js";
import { moduleModal } from "./javascript/modal";
import { moduleProgress } from "./javascript/progressbar";
import { BluetoothCom } from "./javascript/bluetooth";

Vue.config.productionTip = false;

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    deviceInfo: {},
    activeMenu: {}, // Rodykle i aktyvu "menu" masyvo elementa
    allMenu: [], // Menu masyvas. Tiesiai is device.
    activeGroups: [], // Šiuo metu aktyviame menu esančios grupės
    loggedIn: 0,
    loggedUser: "",
  },
  mutations: {
    activateMenu(state, Menu) {
      state.activeMenu = Menu;
    },
    setLogin(state, OnOff) {
      state.loggedIn = OnOff;
    },
    setLoggedUser(state, User) {
      state.loggedUser = User;
    },
    setActiveGroups(state, Groups) {
      state.activeGroups = Groups;
    },
    setMenu(state, obj) {
      state.allMenu = obj;
    },
    setDeviceInfo(state, obj) {
      state.deviceInfo = obj;
    },
  },
  getters: {
    getMenu(state) {
      return state.allMenu;
    },
    getActiveMenu(state) {
      return state.activeMenu;
    },
    getDeviceInfo(state) {
      if (state.deviceInfo) return state.deviceInfo;
      else return "";
    },
    getLogin(state) {
      return state.loggedIn;
    },
    getLoggedUser(state) {
      if (state.loggedIn) return state.loggedUser;
      else return "";
    },
    getLangStrings(state) {
      return {
        username: state.LANG_USERNAME,
        password: state.LANG_PASSWORD,
        login: state.LANG_LOGIN,
      };
    },
    getActiveGroups(state) {
      return state.activeGroups;
    },
  },
  modules: {
    msg: moduleMsg,
    prgBar: moduleProgress,
    modal: moduleModal,
    blue: BluetoothCom,
    status: statusParams,
  },
});
/******************************** Utils ******************************************/

export const GetParamString = function(Buffer, offset, length, encoding) {
  var myBuffer;
  let decoder = new TextDecoder(encoding);
  myBuffer = Buffer.buffer.slice(offset, offset + length);

  return decoder
    .decode(myBuffer, { stream: true })
    .replace(/\0.*$/g, "")
    .trim();
};
export const GetVersionString = function(Buffer, offset, length) {
  return (
    Buffer.getUint8(offset + 1).toString() +
    "." +
    Buffer.getUint8(offset).toString()
  );
};
export const GetParamUInt = function(Buffer, offset, length) {
  switch (length) {
    case 1:
      return Buffer.getUint8(offset);
    case 2:
      return Buffer.getUint16(offset);
    case 4:
      return Buffer.getUint32(offset);
  }
};

export const statusSpecHandle = function(grp, param, Value) {
  var newValue;
  if (param.specFunc === "specResolution") {
    if (GetParamUInt(Value, param.offset, param.length) === 0) newValue = " ";
    else
      newValue =
        GetParamUInt(Value, param.offset, param.length).toString() +
        " x " +
        GetParamUInt(
          Value,
          param.specFuncData2,
          param.specFuncData3
        ).toString();
    store.commit("setStatusParamValue", {
      groupId: grp.id,
      paramId: param,
      value: newValue,
    });
  } else if (param.specFunc === "upTime") {
    var date = new Date(null);
    date.setSeconds(GetParamUInt(Value, param.offset, param.length)); // specify value for SECONDS here
    newValue = date.toISOString().substr(11, 8);
    store.commit("setStatusParamValue", {
      groupId: grp.id,
      paramId: param,
      value: newValue,
    });
  } else if (param.specFunc === "sysStatus") {
    switch (GetParamUInt(Value, param.offset, param.length)) {
      case 0:
        newValue = "Initialization";
        break;
      case 1:
        newValue = "No video input (Idle)";
        break;
      case 2:
        newValue = "Transmitting (Running)";
        break;
      case 3:
        newValue =
          "System Fault (Failure) Code:" +
          GetParamUInt(
            Value,
            param.specFuncData2,
            param.specFuncData3
          ).toString();
        break;
    }
    store.commit("setStatusParamValue", {
      groupId: grp.id,
      paramId: param,
      value: newValue,
    });
  }
};
export const checkAvailability = function(arr, val) {
  return arr.some(function(arrVal) {
    return val === arrVal.id;
  });
};
/*********************************************************************************/
export const loadMenuFromDevice = function() {
  //if (test.test(window.location.href)) {
  store.commit("setMenu", menuData);
  menuData.forEach(function(menu) {
    var test = new RegExp(menu.url + "$");
    if (test.test(window.location.href)) {
      store.commit("activateMenu", menu); // Kuo daugiau testų, tuo geriau veikia ;)
      if (menu.statusGroups) {
        menu.statusGroups.forEach(function(grp) {
          if (grp.params) {
            store.commit("addStatusParams", grp);
          }
        });
      }
    }
  });
  //}
};
// export const   ReadDeviceInfo = async function(){

//   var informationGroup

//   var Value = await  store.dispatch('getPageParamsValue',{suuid:'51600001-b08a-f884-e678-231e36ee5687', cuuid:'5160000d-b08a-f884-e678-231e36ee5687'})

//   for (let index = 0; index < store.getters.getActiveMenu.informationGroup.params.length; index++) {
//     const param = store.getters.getActiveMenu.informationGroup.params[index];
//     if(Value)
//     {
//       var newValue
//       if(param.type === 4) // string
//       newValue = GetParamString(Value,param.offset,param.length,param.encoding)
//       else if(param.type === 0)//Number
//       newValue = GetParamUInt(Value,param.offset,param.length)
//       else if(param.type === 2)//Enum
//       newValue = GetParamUInt(Value,param.offset,param.length)
//       else if(param.type === 99) // versija major ir minor
//       newValue = GetVersionString(Value,param.offset,param.length)
//       else if(param.type === 3)//Bool
//       newValue = GetParamUInt(Value,param.offset,param.length)

//       if(param.decimal)
//         newValue = newValue /param.decimal

//         param.value = newValue
//         //informationGroup.push(param)
//         store.commit('setDeviceInfo', param)
//         informationGroup = param
//     }
//   }

// }
export const updateStatusParams = function() {
  var Groups = store.getters.getListOfStatusGroups;
  if (Groups && Groups.length > 0) {
    Groups.forEach(function(grp) {
      if (grp.cuuid)
        store
          .dispatch("getPageParamsValue", {
            suuid: grp.suuid,
            cuuid: grp.cuuid,
          })
          .then(
            function(Value) {
              grp.cvalue = Value;
              grp.params.forEach(function(param, index) {
                var newValue;
                if (Value) {
                  if (param.type === 4)
                    // string
                    newValue = GetParamString(
                      Value,
                      param.offset,
                      param.length,
                      param.encoding
                    );
                  else if (param.type === 0)
                    //Number
                    newValue = GetParamUInt(Value, param.offset, param.length);
                  else if (param.type === 2)
                    //Enum
                    newValue = GetParamUInt(Value, param.offset, param.length);
                  else if (param.type === 99)
                    // versija major ir minor
                    newValue = GetVersionString(
                      Value,
                      param.offset,
                      param.length
                    );
                  else if (param.type === 3)
                    //Bool
                    newValue = GetParamUInt(Value, param.offset, param.length);

                  if (param.decimal) newValue = newValue / param.decimal;
                  if (param.specFunc) statusSpecHandle(grp, param, Value);
                  else
                    store.commit("setStatusParamValue", {
                      groupId: grp.id,
                      paramId: param,
                      value: newValue,
                    });
                }
              });
            },
            function(err) {
              console.log("getStatusParams: " + err.statusText);
            }
          );
    });
    if (store.getters.getConnection) setTimeout(updateStatusParams, 1500);
  } else if (store.getters.getConnection) setTimeout(updateStatusParams, 1500);
};

export const loadGroupsFromDevice = async function(groupId) {
  var DeviceName = store.getters.getDeviceName;
  var pagesStruct = mhd001;

  if (DeviceName == "MHD003") pagesStruct = mhd003;
  if (DeviceName == "MHD004") pagesStruct = mhd003;
  if (DeviceName == "HDM-01") pagesStruct = hdc001;

  if (!!pagesStruct[groupId])
    if (Array.isArray(pagesStruct[groupId].groups)) {
      store.commit("setActiveGroups", pagesStruct[groupId].groups);

      if (!!regions) {
        var RegionValue = await store.dispatch("getPageParamsValue", {
          suuid: regions.suuid,
          cuuid: regions.cuuid,
        });
        if (RegionValue)
          RegionValue = GetParamUInt(
            RegionValue,
            regions.offset,
            regions.length
          );
      } else RegionValue = null;

      if (pagesStruct[groupId].groups) {
        pagesStruct[groupId].groups.forEach(async function(grp, idx0) {
          if (grp.suuid)
            var ParamsValue = await store.dispatch("getPageParamsValue", {
              suuid: grp.suuid,
              cuuid: grp.cuuid,
            });
          if (grp.params) {
            var Params = {};
            grp.cvalue = ParamsValue;
            grp.params.forEach(function(param) {
              if (param.type === 100) {
                Params[param.id] = param.value;
              }
              if (ParamsValue) {
                if (param.type === 4)
                  // string
                  param.value = GetParamString(
                    ParamsValue,
                    param.offset,
                    param.length,
                    param.encoding
                  );
                else if (param.type === 0)
                  //Number
                  param.value = GetParamUInt(
                    ParamsValue,
                    param.offset,
                    param.length
                  );
                else if (param.type === 2)
                  //Enum
                  param.value = GetParamUInt(
                    ParamsValue,
                    param.offset,
                    param.length
                  );
                else if (param.type === 99)
                  // versija major ir minor
                  param.value = GetVersionString(
                    ParamsValue,
                    param.offset,
                    param.length
                  );
                else if (param.type === 3)
                  //Bool
                  param.value = GetParamUInt(
                    ParamsValue,
                    param.offset,
                    param.length
                  );
              }
              if (RegionValue) {
                var currentRegion = regions.regions[RegionValue - 1];
                if (!!currentRegion)
                  if (!!currentRegion.params)
                    if (checkAvailability(currentRegion.params, param.id)) {
                      var paramOption = regions.regions.params.find(
                        (x) => x.id === param.id
                      ).options;
                      if (!!paramOption) param.options = paramOption;
                    }
              }
              if (param.specFunc == "disableParams")
                specFuncHandler(
                  grp.params,
                  param.value,
                  groupId,
                  grp,
                  param.id
                );
            });
            // if (Object.keys(Params).length > 0) store.commit('addStatusParams', {
            //   id: grp.id,
            //   params: Params
            // })
          } else if (grp.groups) {
            // JSON.stringify(grp.groups)
            grp.groups.forEach(async function(group, idx1) {
              var ParamsValue = await store.dispatch("getPageParamsValue", {
                suuid: group.suuid,
                cuuid: group.cuuid,
              });
              if (group.params) {
                var Params = {};
                group.cvalue = ParamsValue;
                group.params.forEach(function(param, idx2) {
                  if (param.type === 100) {
                    Params[param.id] = param.value;
                  }
                  if (ParamsValue) {
                    if (param.type === 4)
                      // string
                      param.value = GetParamString(
                        ParamsValue,
                        param.offset,
                        param.length,
                        param.encoding
                      );
                    else if (param.type === 0)
                      //Number
                      param.value = GetParamUInt(
                        ParamsValue,
                        param.offset,
                        param.length
                      );
                    else if (param.type === 2)
                      //Enum
                      param.value = GetParamUInt(
                        ParamsValue,
                        param.offset,
                        param.length
                      );
                    else if (param.type === 99)
                      // versija major ir minor
                      param.value = GetVersionString(
                        ParamsValue,
                        param.offset,
                        param.length
                      );
                    else if (param.type === 3)
                      //Bool
                      param.value = GetParamUInt(
                        ParamsValue,
                        param.offset,
                        param.length
                      );
                  }
                  if (RegionValue) {
                    var currentRegion = regions.regions[RegionValue - 1];
                    if (!!currentRegion)
                      if (!!currentRegion.params)
                        if (checkAvailability(currentRegion.params, param.id)) {
                          var paramOption = currentRegion.params.find(
                            (x) => x.id === param.id
                          ).options;
                          if (!!paramOption) param.options = paramOption;
                        }
                  }
                  if (param.specFunc && param.specFunc === "chBandwidth") {
                    // alert(JSON.stringify(mainVue.$store.state.activeGroups[idx0].groups[idx1].params[idx2].value)) // [idx1].params[idx2].value)
                    // mainVue.$watch(mainVue.$store.state.activeGroups[idx0].groups[idx1].params[idx2].value, specFuncBW)
                    // mainVue.$watch('mainVue.$store.state.activeGroups[' + idx0 + '].groups[' + idx1 + '].params[' + idx2 + '].value', specFuncBW)
                    // alert('groups[' + idx1 + '].params[' + idx2 + '].value', specFuncBW)
                    // Vue.$watch('groups[' + idx1 + '].params[' + idx2 + '].value', specFuncBW)
                  }
                });
                // if (Object.keys(Params).length > 0) store.commit('addStatusParams', {
                //   id: group.id,
                //   params: Params
                // })
              }
            });
          }
        });
      }
    }
};

router.afterEach((to, from) => {
  var found = false;
  store.getters.getMenu.forEach(function(menuItem) {
    if (to.path === menuItem.url) {
      store.commit("activateMenu", menuItem);
      found = true;
    } else if (found === false) {
      // Pabandysim ilysti i gilesnius menu
      if (menuItem.menu) {
        menuItem.menu.forEach(function(subMenu) {
          if (to.path === subMenu.url) {
            store.commit("activateMenu", subMenu);
            found = true;
          }
        });
      }
    }
  });
});

/* eslint-disable no-new */
export const mainVue = new Vue({
  vuetify,
  el: "#app",
  store,
  router,
  template: "<App/>",
  components: {
    App,
  },
  render: (h) => h(App),
}).$mount("#app");
